// Adds a method to jquery. Method called isInViewport, returns a boolean, and verifies if the selected element is in the viewport. This method has as vertical offset of 300px. This may cause elements to return 'true' at a 'later' experience.
$.fn.isInViewport = function () {
  const elementTop = $(this).offset().top + $(window).height() - 300
  const elementBottom = elementTop + $(this).outerHeight()

  const viewportTop = $(window).scrollTop()
  const viewportBottom = viewportTop + $(window).height()

  return elementBottom > viewportTop && elementTop < viewportBottom
}

// Adds an event listener, to be triggered every time the user scrolls (or swipe up in mobile) or resizes the window.
$(window).on('resize scroll', function () {
  if (window.location.href.indexOf('/service') !== -1) {
    // Select all elements that contain '.section__qa-setup' class and apply a forEach loop.
    $('.section__qa-setup').each(function () {
      if ($(this).isInViewport()) {
        // Declare constants to hold each element that are going to be affected in each section
        const $background = $(this).find('.half-fill')
        const $header = $(this).find('.service__question')
        const $aTag = $(this).find('.service__letter-a')
        const $aText = $(this).find('.service__name')
        const $line = $(this).find('.vertical-line')

        // Add classes to trigger animations on qa-setup sections.
        $background.addClass('active')
        $header.css('animation-delay', '.25s')
          .addClass('animated fadeInLeft')
        $aTag.css('animation-delay', '.5s')
          .addClass('animated fadeIn')
        $aText.css('animation-delay', '.75s')
          .addClass('animated fadeIn')
        $line.css('animation-delay', '1s')
          .addClass('active')
      } else {
        // Declare constants to hold each element that are going to be affected in each section
        const $background = $(this).find('.half-fill')
        const $header = $(this).find('.service__question')
        const $aTag = $(this).find('.service__letter-a')
        const $aText = $(this).find('.service__name')
        const $line = $(this).find('.vertical-line')

        // Remove classes that were added in previous section.
        $background.removeClass('active')
        $header.css('animation-delay', '.25s')
          .removeClass('animated fadeInLeft')
        $aTag.css('animation-delay', '.5s')
          .removeClass('animated fadeIn')
        $aText.css('animation-delay', '.75s')
          .removeClass('animated fadeIn')
        $line.css('animation-delay', '1s')
          .removeClass('active')
      }
    })
  }
})

if ($('.sequence-wrapper').length !== 0) {
  $(window).on('resize scroll', function () {
    // Still using the scroll listener, check if the section the user is on has a background video or not. If not removes the display property
    if ($('.bg-video-wrapper').isInViewport()) {
      $('video#bgvid').css('display', 'inline-block')
    } else {
      $('video#bgvid').css('display', 'none')
    }
    $('.text-holder').each(function () {
      if (($(this).offset().top - $(window).scrollTop()) <= 650) {
        $('.text-holder.active').removeClass('active')
        $(this).addClass('active')
      }
    })

    if (($('#transformation-screen').offset().top - $(window).scrollTop()) <= 650) {
      $('.transformation-screen > .strip span:not(".row")').each((i, e) => {
        setTimeout(function () {
          $(e).addClass('animate')
        }, i * 15)
      })
      $('.arrow-navigator').attr('href', '#work')
    } else {
      $('.arrow-navigator').attr('href', '#transformation-screen')
    }
  })
}

$(window).ready(function () {
  const $header = $(this).find('.animate__header')
  const $aText = $(this).find('.animate__subheader')
  const $line = $(this).find('.animate__line')

  // Add classes to trigger animations on qa-setup sections.
  $header.css('animation-delay', '.25s')
    .addClass('animated fadeInLeft')
  $aText.css('animation-delay', '.75s')
    .addClass('animated fadeIn')
  $line.css('animation-delay', '1s')
    .addClass('active')
})



// WEBPACK FOOTER //
// ./src/assets/js/_viewPortDetect.js